<template lang="html">
    <div>
      <div class="post_top">
        <van-cell-group>
          <van-field label="版块" v-model="blockName" placeholder='选择版块' readonly :disabled='disabled'  />
          <van-field label="主题" v-model='threadName' placeholder='选择主题分类' readonly :disabled='disabled' @click='pickThread'/>
          <van-field label="标题" v-model="title" placeholder='标题'/>
          
        </van-cell-group>
      </div>
        <vue-html5-editor :content="content" :height="300"  
                          @change="updateData"></vue-html5-editor> 
        <div v-show="blockshow">
          <van-picker  :columns="catlist" @change="onChange"/>
        </div>
        <div v-show="threadshow">
          <van-picker  :columns="threadlist" show-toolbar @confirm="selectConfirm" @cancel="selectCancel" @change="selectThread"/>
        </div>
        <van-button size="large" @click='postThread'>发表帖子</van-button>
        
    </div>
</template>
<script>
import Vue from 'vue'
import initRichText from '@/utils/html5_edit'
import { Cell, CellGroup } from 'vant'
import utilAxios from '@/utils/axios'
import Qs from 'qs'
import { Picker } from 'vant'; 
import { Toast } from 'vant';

Vue.use(Toast);
Vue.use(Picker);
Vue.use(Cell).use(CellGroup) 
initRichText();
export default {
    data(){  
          return {
            title:'',
            fid:'',
            blockName:'',
            blockshow:false,
            formhash:'',
            post_time:'',
           

            catlist:[
              {
                fid:1,
                
                text: '版块1',
              },
              {
                fid:2,
                
                text: '版块2',
              },
              {
                fid:3,
                text: '版块3',
                
              },
              {
                fid:4,
                text: '版块4',
                
              },
            ],
            fid:0,
            type_id:'',
            threadName:'',
            threadshow:false,
            threadlist:[
              {
                type_id:1,
                
                text: '主题1',
              },
              {
                type_id:2,
                
                text: '主题2',
              },
              {
                type_id:3,
                
                text: '主题3',
              }
            ],

            content: ''
          }  
        }, 
        created() {
          this.getPostInfo()
        }, 
        methods: {  
          updateData(e = ''){  
            this.content = e;  
            console.info(e);  
          },
          pickBlock(){
            this.blockshow=true;
            console.log('ddddd')
          },
          onChange(picker, value, index) {
            this.blockName=value.text;
            this.fid=value.fid;
            this.blockshow=false;
          },
          getPostInfo(){
            utilAxios.get({
              url: '/new_api.php?module=forum&mod=post&action=edit&tid='+ this.$route.params.tid+'&pid='+this.$route.query.pid,
              method: 'GET',
              callback: (res) => {
                if (res.data.code == 100) {
                  this.blockName=res.data.navcat;
                  this.title=res.data.content.subject;
                  this.content=res.data.content.message;
                  this.fid=res.data.content.fid;
                  this.threadName=res.data.typename;
                  this.type_id=res.data.type_id;
                  this.threadlist=res.data.type_list;
                  this.formhash=res.data.formhash;
                  this.post_time=res.data.cur_time;
                }else{
                  Toast(res.msg);
                }
                
             
              }
            })
          },
          pickThread(){
            this.threadshow=true;
            console.log('ddddd')
          },
           selectThread(picker, value, index) {
            
          },
          selectConfirm(value, index){
            this.threadName=value.text;
            this.type_id=value.type_id;
            this.threadshow=false;
          },
          selectCancel(value,index){
            this.threadshow=false;
          },
          postThread(){
            let params={
              formhash:this.formhash,
              posttime:this.post_time,
              wysiwyg:1,
              fid:this.fid,
              tid:this.$route.params.tid,
              pid:this.$route.query.pid,
              typeid:this.type_id,
              subject:this.title,
              message:this.content,
              replycredit_extcredits:0,
              replycredit_times:1,
              replycredit_membertimes:1,
              replycredit_random:100,
              allownoticeauthor:1,
              usesig:1,
            }
            utilAxios.formpost({
              url: '/new_api.php?module=forum&mod=post&action=edit&editsubmit=yes',
              method: 'POST',
              data:Qs.stringify(params),
              callback: (res) => {
                if (res.data.code == 100) {
                     Toast.success(res.data.msg)
                    this.$router.push('/article/'+res.data.tid) 
                   } else {
                     Toast.fail(res.data.msg)
                   }
              }
            })
          
          }


        }  
}; 
</script>
<style>
  .vue-html5-editor img{
    max-width:100%;
  }
  .post_top .van-field .van-cell__title{
   max-width:50px;
  }
</style>
<style lang="scss" scoped>
  .vue-html5-editor{
    margin-bottom:60px;
  }
  .van-picker{
    position:fixed;
    width:100%;
    left:0px;
    bottom:0px;
    z-index:10;
  }
  .van-button{
    position:fixed;
    background-color:#f44;
    border-color:#f44;
    color:#fff;
    left:0px;
    bottom:0px;
    z-index:9;

  }
</style>


// WEBPACK FOOTER //
// src/pages/Post/Edit.vue